// Qué hacer cuando el silo rechaza «Marcar entregado»: el `code` decide si se relee o se oculta el botón.
import { ApiError, userMessageOf } from '@/api/errors';

/** `reload` relee la lista; `hide` quita el botón de esa fila sin reintentar; `retry` deja intentar otra vez. */
export type DeliverFailureAction = 'reload' | 'hide' | 'retry';

export interface DeliverFailure {
    message: string;
    action: DeliverFailureAction;
    /** Leyenda que sustituye al botón cuando la acción es `hide`. */
    note?: string;
}

const FAILURE_BY_CODE: Record<string, DeliverFailure> = {
    PENDING_REFUND_NOT_FOUND: {
        message: 'Este reembolso ya no existe. Actualizamos la lista.',
        action: 'reload',
    },
    PENDING_REFUND_ALREADY_DELIVERED: {
        message: 'Alguien ya lo marcó como entregado. Actualizamos la lista.',
        action: 'reload',
    },
    PENDING_REFUND_NOT_CASH: {
        message: 'El enganche no se cobró en efectivo: lo procesa Finanzas.',
        action: 'hide',
        note: 'Lo procesa Finanzas',
    },
    PENDING_REFUND_PAYMENT_METHOD_UNKNOWN: {
        message: 'No sabemos cómo se cobró el enganche, así que no se puede entregar en tienda.',
        action: 'hide',
        note: 'Sin forma de cobro registrada',
    },
};

export function deliverFailureOf(error: unknown): DeliverFailure {
    if (error instanceof ApiError) {
        if (Object.hasOwn(FAILURE_BY_CODE, error.code)) return FAILURE_BY_CODE[error.code];
        if (error.httpStatus === 403) {
            return {
                message: 'No tienes permiso para anotar devoluciones de enganche.',
                action: 'hide',
            };
        }
    }
    return { message: userMessageOf(error), action: 'retry' };
}
